<template>
    <div>
        <div class="title">
                规章流程
        </div>
        <a-table :columns="columns" :data-source="data" :pagination='false' >
            <template slot="operation" slot-scope="text">
                <a href="#" @click="exportWj(text)">下载</a>
            </template>
        </a-table>
        
    </div>
</template>
<script>
export default {
    data () {
        return {
            columns:[
                {
                    title: '序号',
                    dataIndex: 'xh',
                    key: ''
                },
                {
                    title: '文件号',
                    dataIndex: 'wjh',
                    key: ''
                },
                {
                    title: '文件名',
                    dataIndex: 'wjm',
                    key: ''
                },
                {
                    title: '印发时间',
                    dataIndex: 'yfsj',
                    key: ''
                },
                {
                    title: '操作',
                    dataIndex: 'url',
                    scopedSlots: { customRender: 'operation' }
                },
            ],
            data:[
                {
                    xh:"1",wjh:"经院字〔2023〕第 004 号",wjm:"经院字〔2023〕第004号关于印发《经济学院教师因公出国（境）申请流程》的通知",yfsj:"2023/6/5",url:this.$store.state.axiosUrl+'/api-f/statics/template/经院字〔2023〕第004号关于印发《经济学院教师因公出国（境）申请流程》的通知.pdf'
                },
                {
                    xh:"2",wjh:"经院字〔2023〕第 005 号",wjm:"经院字〔2023〕第005号关于印发《经济学院交换生出国（境）学习申请流程》的通知",yfsj:"2023/6/5",url:this.$store.state.axiosUrl+'/api-f/statics/template/经院字〔2023〕第005号关于印发《经济学院交换生出国（境）学习申请流程》的通知.pdf'
                },
                {
                    xh:"3",wjh:"附件1",wjm:"经济学院教师出国（境）院内申请附件",yfsj:"2023/6/5",url:this.$store.state.axiosUrl+'/api-f/statics/template/经济学院教师出国（境）院内申请附件.docx'
                },
                {
                    xh:"4",wjh:"附件2",wjm:"经济学院出国（境）交换生院内申请流程附件",yfsj:"2023/6/5",url:this.$store.state.axiosUrl+'/api-f/statics/template/经济学院出国（境）交换生院内申请流程附件.docx'
                }
            ]
        }
    },
    methods:{
        exportWj(url){
            window.open(url)
        },
    }

}
</script>

<style scoped>
    .title{
        font-weight:bold;
        font-size: 1.5rem;
        text-align: center;
        margin-bottom: 1rem;
    }
</style>